<template>
  <form-dialog title="添加字体" :dialogVisible="visible" @closeDialog="closeDialog">
    <div class="font-add">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="所属区域">
          <el-select v-model="form.foreign">
            <el-option label="国内" :value="1"></el-option>
            <el-option label="国外" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="字体文件" prop="fileList">
          <el-upload action="/api/admin/template/addMaterial" :limit="1" :accept="'font/ttf'" :data="uploadParams" :auto-upload="false" :before-upload="beforeUpload" :file-list="fileList" :on-success="handleSuccess" ref="upload">
            <el-button type="primary" size="small">选择文件</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
    <div class="footer">
      <el-button round @click="cancel">取消</el-button>
      <el-button type="primary" round @click="confirm">确定</el-button>
    </div>
  </form-dialog>
</template>

<script>
import FormDialog from '@/components/basics/FormDialog';
import {
  handleDataAndSign
} from "@/assets/scripts/handleDataAndSign";
export default {
  name: 'FontAdd',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    themeId: {
      type: Number,
      default: 0
    }
  },
  components: {
    FormDialog
  },
  data() {
    const fontExt = ['ttf', 'otf', 'woff', 'woff2', 'eot', 'svg'];
    const fontValidate = (rule, value, callback) => {
      const file = this.$refs.upload.uploadFiles[0];
      if (fontExt.includes(file.name.split('.').pop().toLowerCase())) {
        callback();
      } else {
        callback(new Error('请上传正确的字体格式文件'));
      }
    }
    return {
      form: {
        foreign: 1,
        fileList: []
      },
      fileList: [],
      uploadParams: {

      },
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        fileList: [
          { required: true, validator: fontValidate, trigger: 'change' }]
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog', false);
    },
    cancel() {
      this.$emit('closeDialog', false);
    },
    confirm() {
      this.$refs.form.validate(validate => {
        if (validate) {
          this.$refs.upload.submit();
        }
      })
    },
    beforeUpload() {
      const formData = {
        foreign: this.form.foreign,
        type: 19,
        theme_id: this.themeId,
        group_id: this.$cookies.get('group_id')
      };
      const data = handleDataAndSign('/admin/template/addMaterial', formData);
      this.uploadParams.foreign = this.form.foreign;
      this.uploadParams.type = 19;
      this.uploadParams.theme_id = this.themeId;
      this.uploadParams.group_id = formData.group_id;
      const { v, s, t, token } = data;
      this.uploadParams.v = v;
      this.uploadParams.s = s;
      this.uploadParams.t = t;
      this.uploadParams.token = token;
    },
    handleSuccess(resp) {
      if (resp.data) {
        // 成功则刷新
        this.$emit('closeDialog', true);
      }
      console.log('resp', resp)
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>